module.exports = __webpack_public_path__ + "img/Apartments.bca716fe.svg";